<template>
  <div>

    <div class="col-md-6 text-center mx-auto">
      <h3>Quais apps você deseja utilizar?</h3>
      <p>Selecione um ou mais apps abaixo</p>
    </div>

    <div class="col-md-10 mx-auto mt-5">
      <div class="row mx-auto">
        <div class="col-md-4" v-for="module in modules" :key="module.name">
          <div class="card">
            <div class="card-body text-center">

              <div class="icon mx-auto">
                <component :is="module.icon" size="3x"/>
              </div>

              <p class="card-text mt-3">{{ module.description }} <InfoIcon v-tooltip.right="module.appDescription"/></p>

              <button v-if="!module.selected" class="btn btn-outline" @click="addApp(module)">
                Ativar App
              </button>

              <button v-else title="Clique para desativar" class="btn btn-outline-active" @click="removeApp(module)">
                App ativado
              </button>

            </div>
          </div>
        </div>
      </div>

      <div class="col-md-10 mx-auto text-center mt-5">
        <button @click="save()" :disabled="enableNextButton" class="btn btn-primary btn-block col-md-5">Próximo Passo</button>
      </div>
    </div>

  </div>
</template>

<script>
  import { BookIcon, FileTextIcon, InfoIcon, MailIcon, FileIcon } from 'vue-feather-icons'
  import GetAccount from '@/mixins/GetAccount'
  import GetPartner from '@/mixins/GetPartner'
  import { getAppDisplayName } from '@/appDisplayNames'

  export default {
    components: { BookIcon, FileTextIcon, InfoIcon, MailIcon, FileIcon },
    computed: {
      enableNextButton() {
        return !this.modules.some((module) => module.selected)
      }
    },
    created() {
      if (!Array.isArray(this.account.cacheAppIds))
        this.$set(this.account, 'cacheAppIds', [])

      this.axios.get('apps')
        .then(response => this.apps = this.$parse.toCamelcase(response.data))
        .then(() => {
          this.modules = this.modules.map(module => {
            let app = this.apps.find(app => app.name === module.name)
            const description = getAppDisplayName(module.name)
            return {...app, ...module, description}
          })

          this.modules.forEach(module => {
            if (this.account.cacheAppIds.includes(module.id))
              module.selected = true
          })
        })
    },
    data() {
      return {
        apps: [],
        modules: [
          { icon: 'FileTextIcon', name: 'dfe', selected: false, appDescription: 'Capture e gerencie seus documentos fiscais eletrônicos', },
          { icon: 'FileIcon', name: 'cm-frotas', selected: false, appDescription: 'Mantenha as multas da sua frota sob controle', },
          { icon: 'FileIcon', name: 'cm-taxas', selected: false, appDescription: 'Monitore as taxas de IPVA e licenciamento da sua frota', },
          { icon: 'FileIcon', name: 'cm-embarcador', selected: false, appDescription: 'Monitore as multas de embarcador emitidas contra o(s) seu(s) CNPJs', },
          { icon: 'FileIcon', name: 'cm-crono', selected: false, appDescription: 'Monitore os prazos de vencimento dos certificados com informações trazidas diretamente do portal do INMETRO', },
        ],
      }
    },
    methods: {
      addApp(app) {
        app.selected = true
        this.account.cacheAppIds.push(app.id)
      },
      async enableApp(app) {
        return this.axios.post('/account_apps', { account_app: { app_id: app.id } })
      },
      removeApp(app) {
        app.selected = false
        const index = this.account.cacheAppIds.findIndex(a => app.id === a)
        if (index > -1)
          this.account.cacheAppIds.splice(index, 1)
      },
      save() {
        this.$emit('nextStep')
      }
    },
    name: 'Apps',
    props: {
      account: { required: true, type: Object }
    },
    mixins: [GetAccount, GetPartner]
  }
</script>

<style scoped>

  .icon {
    width: 64px;
    height: 64px;
    background: linear-gradient(226.14deg, #FFFFFF 6.78%, #FFFFFF 118.87%);
    box-shadow: 0 2px 5px rgba(31, 118, 204, 0.15);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon svg {
    color: #318BE3;
  }

  .card-text {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 163.19%;

    text-align: center;
    color: #051B30;
  }

  .card button {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
  }

</style>
